import type { FormProps } from "@emkit/builder-widgets";
import { useEditor } from "../../store.js";
import { CheckboxField, SelectField, TextField } from "./fields.js";
import type { WidgetInspectorProps } from "./registry.js";

const METHODS = ["POST", "GET"] as const;
const VARIANTS = ["primary", "secondary"] as const;

export function FormInspector({ widget }: WidgetInspectorProps) {
  const update = useEditor((s) => s.updateWidgetProps);
  const p = widget.props as FormProps;

  return (
    <>
      <TextField
        label="Submit URL"
        value={p.action}
        onChange={(v) => update(widget.id, { action: v })}
      />
      <SelectField
        label="Method"
        value={p.method}
        options={METHODS}
        onChange={(v) => update(widget.id, { method: v })}
      />

      <div className="emke-section-title" style={{ marginTop: 8 }}>
        Fields
      </div>
      <CheckboxField
        label="Show name field"
        value={p.showName}
        onChange={(v) => update(widget.id, { showName: v })}
      />
      {p.showName && (
        <TextField
          label="Name label"
          value={p.nameLabel}
          onChange={(v) => update(widget.id, { nameLabel: v })}
        />
      )}

      <CheckboxField
        label="Show email field"
        value={p.showEmail}
        onChange={(v) => update(widget.id, { showEmail: v })}
      />
      {p.showEmail && (
        <TextField
          label="Email label"
          value={p.emailLabel}
          onChange={(v) => update(widget.id, { emailLabel: v })}
        />
      )}

      <CheckboxField
        label="Show message field"
        value={p.showMessage}
        onChange={(v) => update(widget.id, { showMessage: v })}
      />
      {p.showMessage && (
        <TextField
          label="Message label"
          value={p.messageLabel}
          onChange={(v) => update(widget.id, { messageLabel: v })}
        />
      )}

      <div className="emke-section-title" style={{ marginTop: 8 }}>
        Button
      </div>
      <TextField
        label="Text"
        value={p.buttonText}
        onChange={(v) => update(widget.id, { buttonText: v })}
      />
      <SelectField
        label="Variant"
        value={p.buttonVariant}
        options={VARIANTS}
        onChange={(v) => update(widget.id, { buttonVariant: v })}
      />
    </>
  );
}
